import { isRTLLocale } from '@wix/cashier-common/dist/src/utils/isRTLLocale';
import React from 'react';
import { TPAComponentsProvider } from 'wix-ui-tpa/TPAComponentsConfig';
import { IInternalCashierPaymentsProps } from '../../../cashier-payments';

export const withTPAProvider =
  (Widget: React.ComponentClass<IInternalCashierPaymentsProps>) =>
  (props: IInternalCashierPaymentsProps) =>
    (
      <TPAComponentsProvider
        value={{
          mobile: props.deviceType === 'mobile',
          rtl: isRTLLocale(props.configuration.locale || props.locale),
        }}
      >
        <Widget {...props} />
      </TPAComponentsProvider>
    );
